import assert from 'assert-ts';
import {DropTargetOffsets} from '@di-nxt/components';
import {Task} from '../../../services';
export const getDropSequenceNo = (
  task: Task,
  shiftDuration: number,
  tasks: Task[],
  offsets: DropTargetOffsets,
): number => {
  if (tasks.length === 0) {
    return task.taskSequence ?? 100;
  }

  // Task moved to empty shift, i.e. tasks === [task]
  if (tasks.length === 1 && tasks[0].id === task.id) {
    return task.taskSequence ?? 100;
  }

  const pctOffset = offsets.cursorRelative.x / offsets.target.width;
  let accTaskPct = 0;

  /**
   * Position where to insert/move task, 0: first, length: last
   */
  let dropPos = 0;

  while (
    dropPos < tasks.length &&
    pctOffset >
      accTaskPct +
        assert(
          tasks[dropPos].durationMinutesEstimated,
          'getDropSequenceNo: expects durationMinutesEstimated on task',
        ) /
          shiftDuration /
          2
  ) {
    accTaskPct +=
      assert(tasks[dropPos].durationMinutesEstimated) / shiftDuration;
    dropPos++;
  }

  const taskIdx = tasks.findIndex(t => t.id === task.id);

  if (taskIdx >= 0) {
    // Same position, reuse or calc. task sequence
    if (
      taskIdx === dropPos ||
      (dropPos === tasks.length && taskIdx === tasks.length - 1)
    ) {
      // Make sure we have taskSequence based on current position
      const prevSeq = tasks[taskIdx].taskSequence;
      // Reuse prevSeq if still valid
      const calcPrevTaskSequence =
        taskIdx === 0
          ? // First
            prevSeq !== undefined && prevSeq < tasks[1].taskSequence!
            ? prevSeq
            : Math.floor(tasks[1].taskSequence! / 2)
          : taskIdx === tasks.length - 1
          ? // Last
            prevSeq !== undefined && prevSeq > tasks[taskIdx - 1].taskSequence!
            ? prevSeq
            : tasks[taskIdx - 1].taskSequence! + 100
          : // In between
          prevSeq !== undefined &&
            prevSeq > tasks[taskIdx - 1].taskSequence! &&
            prevSeq < tasks[taskIdx + 1].taskSequence!
          ? prevSeq
          : Math.floor(
              (tasks[taskIdx - 1].taskSequence! +
                tasks[taskIdx + 1].taskSequence!) /
                2,
            );
      return calcPrevTaskSequence;
    }
  }

  // First
  if (dropPos === 0) {
    assert.soft(
      (tasks[dropPos].taskSequence ?? 0) > 0,
      'getDropSequenceNo: Prev. first task in target tasklist should have sequence no > 0',
      {tasks, dropPos},
    );

    return Math.floor((tasks[dropPos].taskSequence ?? 0) / 2);
  }

  // Last
  if (dropPos === tasks.length) {
    assert.soft(
      tasks[dropPos - 1].taskSequence,
      'getDropSequenceNo: Prev last task in target tasklist should have sequence no',
      {tasks, dropPos},
    );

    return tasks[dropPos - 1].taskSequence! + 100;
  }

  // In between
  if (taskIdx >= 0) {
  }
  assert.soft(
    (tasks[dropPos].taskSequence ?? 0) -
      (tasks[dropPos - 1].taskSequence ?? 0) >
      1,
    'getDropSequenceNo: Tasks in target tasklist have to tight sequence numbers',
    {tasks, dropPos},
  );

  return Math.floor(
    ((tasks[dropPos].taskSequence ?? 0) +
      (tasks[dropPos - 1].taskSequence ?? 0)) /
      2,
  );
};
